import { render, staticRenderFns } from "./_DataDetail.vue?vue&type=template&id=3e2d5350&scoped=true"
import script from "./_DataDetail.vue?vue&type=script&lang=ts"
export * from "./_DataDetail.vue?vue&type=script&lang=ts"
import style0 from "./_DataDetail.vue?vue&type=style&index=0&id=3e2d5350&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2d5350",
  null
  
)

export default component.exports